<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Stock Adjustment Detail')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="d-flex">
          <!-- <img
            :src="data.thumbnail_url"
            class="images_box_info rounded me-2"
          > -->
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ $t('Stock Adjustment') + ': ' + data.adjustment_no }}
              <span
                style="text-transform: capitalize"
                :class="['badge', data.status == 'draft'? 'bg-secondary': (data.status == 'completed'? 'bg-success': 'bg-danger')]"
              >
                {{ $t(data.status) }}
              </span>
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="card-header">
          <i class="fa-solid fa-circle-info me-2" />
          {{ $t('Stock Adjustment Information') }}
        </div>
        <div class="card-body pb-0">
          <div class="row" style="font-size: 13px;">
            <div class="col-6 col-md-3 mb-3">
              <b>
                <i class="fa-solid fa-calendar-days me-1" />
                {{ $t('Adjustment Date') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              {{ formatDate(data.transaction_date) }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                <i class="fa-solid fa-building me-1" />
                {{ $t('Branch') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              {{ data.branch }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                <i class="fa-solid fa-clipboard-question me-1" />
                {{ $t('Reason') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              <span
                style="text-transform: capitalize"
                :class="['badge', data.reason_type == 'increase'? 'bg-primary': (data.reason_type == 'decrease'? 'bg-danger': 'bg-secondary')]"
              >
                {{ $t(data.reason) }}
              </span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                <i class="fa-solid fa-note-sticky me-1" />
                {{ $t('Note') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              {{ data.note? data.note:'-' }}
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                <i class="fa-solid fa-user-pen me-1" />
                {{ $t('Create By') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              {{ data.created_by }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="border-bottom-0 card-header">
          <i class="fa-solid fa-boxes-stacked me-2" />
          {{ $t('Items') }}
        </div>
        <div class="card-body p-0">
          <vue3-easy-data-table
            ref="datatableItems"
            :headers="datatableItems.headers($t)"
            :items="datatableItems.items"
            :loading="datatableItems.loading"
            :theme-color="'#515151'"
            :hide-footer="true"
            :hide-rows-per-page="true"
            :empty-message="$t('No Available Data')"
            :table-min-height="null"
            :body-item-class-name="bodyItemClassNameFunction"
            table-class-name='customize-table-hide-footer-in-offcanvas'
            no-hover
          >
            <template #header-quantity="header">
              <span class="w-100 text-end">
                {{ header.text }}
              </span>
            </template>
            <template #header-reason_detail="header">
              <span class="w-100 text-end">
                {{ header.text }}
              </span>
            </template>
            <template #item-lot_number="item">
              <span
                :class="[item.quantity > 0? 'text-success': 'text-danger']"
                style="
                  height: 25px !important;
                  font-size: 14px;
                "
              >
                {{ item.lot_number? item.lot_number: '[ '+$t('New Lot Auto-Create')+' ]' }}
              </span>
            </template>
            <template #item-reason_detail="item">
              {{ item.reason_detail? item.reason_detail: '-' }}
            </template>
            <template #item-quantity="item">
              <span
                :class="[item.quantity > 0? 'text-success': 'text-danger']"
              >
                {{ formatNumberTwoDigit(item.quantity) }}
              </span>
            </template>
            <template #item-unit="item">
              {{ $t(item.unit) }}
            </template>
            <template #loading>
              <i class="fa-solid fa-spinner fa-spin fa-2xl" />
            </template>
          </vue3-easy-data-table>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <div
        class="btn-group dropdown"
      >
        <button
          type="button"
          class="btn btn-sm btn-primary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          @mouseenter="isHovered = true"
          @mouseleave="isHovered = false"
        >
          <i class="fa-solid fa-ellipsis me-1" :class="isHovered? 'fa-fade': ''" />
          {{ $t('More Action') }}
        </button>
        <ul class="dropdown-menu">
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.offcanvasFroms.open = true;
                $parent.offcanvasFroms.id = id;
                $parent.offcanvasFroms.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
              {{ $t('Edit') }}
            </a>
          </li>
          <li
            v-if="data.status === 'draft'"
          >
            <a
              class="dropdown-item"
              @click="handleConfirm(id)"
            >
              <i class="fa-solid fa-circle-check" />
              {{ $t('Confirm') }}
            </a>
          </li>
          <li
            v-if="data.status !== 'cancelled'"
          >
            <a
              class="dropdown-item"
              @click="handleCancel(id)"
            >
              <i class="fa-solid fa-ban" />
              {{ $t('Cancel') }}
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import Select2 from 'vue3-select2-component';
import { StockAdjustments } from '@/services/endpoint/stock-adjustments.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import numeral from 'numeral';
import { distance } from '@/store/date-fns'
import Popper from "vue3-popper";
import FieldInfoItems from "./assets/template/datatable/FieldInfoItems";

export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      datatableItems: {
        loading: false,
        headers: FieldInfoItems,
        items: [],
        total: 0,
        params: {
          limit: 10,
          page: 1,
          search: ''
        }
      },
      isHovered: false,
      loadingCard: true,
      loading: true,
      data: {
        name: '',
        code: '',
        quantity: 0,
        cost: 0,
        unit_id: '1',
      },
      tabCards: [
        {
          id: 1,
          name: 'Activity Logs',
          disabled: false
        },
        {
          id: 2,
          name: 'Unusable',
          disabled: false
        }
      ],
      selectTabCard: 1
    }
  },
  components: {
    Vue3EasyDataTable,
    Select2,
    PlaceholderContent,
    Ladda,
    Popper
  },
  methods: {
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top border-0';
      const columnStart = [];
      const columnCenter = [];
      const columnEnd = ['quantity', 'reason_detail'];
      if (columnStart.includes(column)) {
        className += ' text-start';
      }
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getInfoData() {
      await StockAdjustments.getInfo(this.id).then(res => {
        this.data = res.data.data;
        this.datatableItems.items = res.data.data.items;
        this.loading = false;
      }).catch(err => {
			  throw err;
      });
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    dateDistance(value) {
      return distance(value);
    },
    async handleConfirm(id) {
      try {
        let self = this;
        let title = this.$t("Confirm Stock Adjustment") + '?';
        let html = this.$t('This will update the actual stock balances. The document cannot be edited after confirmation. Are you sure') + '?';
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("No, Wait"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return StockAdjustments.confirm(id)
              .then((response) => {
                self.$parent.fetchData();
                self.getInfoData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Confirm Success!'));
                // $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleCancel(id) {
      try {
        let self = this;
        let title = this.$t("Cancel this doc") + '?';
        let html = this.$t('Do you want to cancel this doc stock adjustment? This action cannot be undone.');
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Yes, Cancel Now");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("No, Keep it"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-danger me-2",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          reverseButtons: true, // สลับปุ่มเอา "ยกเลิก" ไว้ซ้าย (กันมือกดผิด)
          focusCancel: true,
          preConfirm: async function () {
            return StockAdjustments.cancel(id)
              .then((response) => {
                self.$parent.fetchData();
                self.getInfoData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Cancel Success!'));
                // $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      try {
        this.loading = true;
        await this.getInfoData();
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$parent.formInfo.open = false;
    });
  },
  computed: {

  },
  watch: {
  }
}
</script>
